var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendarViewA = function SvgCalendarViewA(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V8H20V21ZM20 8H4V5H20V8Z",
    fill: "var(--iconColor, currentColor)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1826 10.5171L10.0557 17H8.34229L11.248 9.17969H12.3384L12.1826 10.5171ZM13.9497 17L11.8174 10.5171L11.6455 9.17969H12.7466L15.6685 17H13.9497ZM13.853 14.0889V15.3511H9.72266V14.0889H13.853Z",
    fill: "var(--iconColor, currentColor)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarViewA);
export { ForwardRef as ReactComponent };